import { render } from "./CommodityPage.vue?vue&type=template&id=74737437&scoped=true"
import script from "./CommodityPage.vue?vue&type=script&lang=js"
export * from "./CommodityPage.vue?vue&type=script&lang=js"

import "./CommodityPage.vue?vue&type=style&index=0&id=74737437&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74737437"]])

export default __exports__